import type React from "react";
import {PageHeader} from "~/components/main/header/PageHeader.tsx";

/** Page title, shown in the app's top bar (Mithra 3.1 header). */
export const TaxonomyBuilderHeader: React.FC = () => <PageHeader title="Taxonomy Builder"/>;
